import "../../arDominionB5Plugin/js/main";

/*

Extra/custom JS:

jQuery, $ and bootstrap are exposed globally. Also Drupal and Qubit,
but avoid its usage. Allows IIFEs, CommonJS, ES6 Modules and it could
allow Typescript if it's implemented in the Webpack build process.

*/
jQuery(document).ready(function() {
  jQuery('#clipboard-menu').on('shown.bs.dropdown', function() {
    var countsBlock = jQuery('#counts-block');
    if (countsBlock.length) {
      var text = countsBlock.html(); // Use .html() to preserve <br> tags
      console.log("Before:", text);

      text = text.replace(/count\s*/g, ''); // Remove all occurrences of "count:"
      
      console.log("After:", text);
      countsBlock.html(text);
    }
  });
});
